import HighlightTitle from '../HighlightCard/HighlightTitle';
import { jsx as _jsx } from "react/jsx-runtime";
const CartHighlightTitle = ({
  title
}) => /*#__PURE__*/_jsx(HighlightTitle, {
  title: title,
  i18nKey: "cartsHighlightCard.title"
});
export default CartHighlightTitle;